import { Heading, Layout, PlaceCenter } from '@components'
import { useNotifications } from '@state'
import { For } from 'solid-js'
import { useService } from 'solid-services'
import { Container, Grid } from 'styled-system/jsx'
import NotificationComponent from '../../features/Notifications/Notification'
import { Sailboat, Sparkle } from 'lucide-solid'

export default function () {
	const { notifications } = useService(useNotifications)()
	return (
		<Container width="100%">
			<Layout
				position="relative"
				maxW="700px"
				margin="0 auto"
			>
				<Heading>Notifications</Heading>
				<For
					each={notifications()}
					fallback={
						<Grid
							justifyItems="center"
							mt={32}
							gap={4}
						>
							<Heading
								size="3xl"
								children="You're up to date"
							/>
							<Sailboat size={150} />
						</Grid>
					}
				>
					{(notification) => <NotificationComponent notification={notification} />}
				</For>
			</Layout>
		</Container>
	)
}
